package org.lennycodes.hldi.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.constants.HLDITheme
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.rows
import org.jetbrains.compose.web.css.AlignSelf
import org.lennycodes.hldi.styles.AppInputStyle
import org.lennycodes.hldi.styles.ButtonStyle
import org.lennycodes.hldi.styles.SendMessageStyle
import org.lennycodes.hldi.styles.SubmitButtonStyle
import org.lennycodes.hldi.styles.TextAreaStyle

@Composable
fun ContactForm(modifier: Modifier = Modifier) {
    Form(
        attrs =
            modifier
                .display(DisplayStyle.Flex)
                .flexDirection(FlexDirection.Column)
                .gap(20.px)
                .toAttrs()

    ) {
        InputField("Full Name", "text")
        InputField("Email Address", "email")
        InputField("Phone Number", "tel")
        InputField("Subject", "text")

        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(8.px)
                }
            }
        ) {
            Label(
                attrs = {
                    style {
                        fontSize(14.px)
                        fontWeight(600)
                        color(HLDITheme.Colors.text)
                    }
                }
            ) {
                Text("Message")
            }
            TextArea(
                attrs = Modifier.padding(12.px)
                    .then(TextAreaStyle.toModifier())
                    .toAttrs {
                        rows(4)
                    }
            )
        }

        Button(
            attrs = Modifier.padding(14.px, 32.px)
                .then(SubmitButtonStyle.toModifier())
                .toAttrs()
        ) {
            Text("Send Message")
        }
    }
}

@Composable
fun VolunteerForm() {
    Form(
        attrs = {
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(20.px)
                backgroundColor(HLDITheme.Colors.white)
                padding(40.px)
                borderRadius(12.px)
                boxShadow(0.px, 4.px, 12.px, color = Color.rgba(0, 0, 0, 0.1f))
            }
        }
    ) {
        InputField("Full Name", "text")
        InputField("Email Address", "email")
        InputField("Phone Number", "tel")

        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(8.px)
                }
            }
        ) {
            Label(
                attrs = {
                    style {
                        fontSize(14.px)
                        fontWeight(600)
                        color(HLDITheme.Colors.text)
                    }
                }
            ) {
                Text("Skills & Experience")
            }
            TextArea(
                attrs = Modifier.padding(12.px)
                    .then(TextAreaStyle.toModifier())
                    .toAttrs {
                        rows(4)
                    }
            )
        }

        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(8.px)
                }
            }
        ) {
            Label(
                attrs = {
                    style {
                        fontSize(14.px)
                        fontWeight(600)
                        color(HLDITheme.Colors.text)
                    }
                }
            ) {
                Text("Why do you want to volunteer?")
            }
            TextArea(
                attrs = Modifier.padding(12.px)
                    .then(TextAreaStyle.toModifier())
                    .toAttrs {
                    rows(4)
                }
            )
        }

        Button(
            attrs = Modifier.padding(14.px, 32.px).then(SubmitButtonStyle.toModifier()).toAttrs()
        ) {
            Text("Submit Application")
        }
    }
}

@Composable
private fun InputField(label: String, type: String) {
    Div(
        attrs = {
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(8.px)
            }
        }
    ) {
        Label(
            attrs = {
                style {
                    fontSize(14.px)
                    fontWeight(600)
                    color(HLDITheme.Colors.text)
                }
            }
        ) {
            Text(label)
        }
        Input(
            type = when (type) {
                "email" -> InputType.Email
                "tel" -> InputType.Tel
                else -> InputType.Text
            },
            attrs = Modifier.padding(12.px)
                .then(AppInputStyle.toModifier())
                .toAttrs {
                    placeholder("Enter your ${label.lowercase()}")
                }
        )
    }
}